// extracted by mini-css-extract-plugin
export default {"sign-in-button":"SignInButton_sign-in-button__S4J3P"};